export const GET_STATIC_DATA = 'GET_STATIC_DATA';

export enum StaticDataActionTypes {
  GET_STATIC_DATA_REQUEST = 'GET_STATIC_DATA_REQUEST',
  GET_STATIC_DATA_SUCCESS = 'GET_STATIC_DATA_SUCCESS',
  GET_STATIC_DATA_FAILURE = 'GET_STATIC_DATA_FAILURE'
}
